<template>
  <div class="homepage-block-right-container">
    <h3>{{ description }}</h3>
    <div class="image-container">
      <a :href="imageHref" :target="imageHrefTarget">
        <img :src="imageurl" :alt="alt" />
      </a>
    </div>
    <div class="button-container">
      <a :href="buttonData[0].buttonLink" role="button" @click="homedatalayer()">
        <strong>{{ buttonData[0].buttonText }}</strong>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home-page-block-right',
  props: {
    buttonData: {
      type: Array,
      required: false,
    },
    imageurl: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    imageHref: {
      type: String,
      required: true,
    },
    imageHrefTarget: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  methods: {
    homedatalayer() {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'home page',
        eventAction: `select::${this.description}`,
        eventLabel: `${this.buttonData[0].buttonText}::${this.buttonData[0].buttonLink}`,
        ecommerce: 'undefined',
        event_name: 'body_button_click',
        module_name: this.description,
        cta_name: this.buttonData[0].buttonText,
        link_url: this.buttonData[0].buttonLink,
      });
    },
  },
};
</script>
